/* eslint-disable max-len */
import React, { useMemo } from 'react';
import { StoryblokComponent, storyblokEditable } from 'gatsby-source-storyblok';
import { graphql, useStaticQuery } from 'gatsby';
import PropTypes from 'prop-types';
import Row from '../../FlexboxGrid/Row.jsx';
import Col from '../../FlexboxGrid/Col.jsx';
import { renderRichTextReact } from '../../../utils/storyblokRichText';
import Separator from '../../../icons/star-wars-separator.svg';

const ProductCard = ({ blok }) => {
  const { borderStyle, description, image, titleRichText } = blok;

  // query border images
  const query = useStaticQuery(graphql`
    {
      borderImageStyleOne: file(name: { eq: "product-card-border-1" }) {
        publicURL
      }
      borderImageStyleTwo: file(name: { eq: "product-card-border-2" }) {
        publicURL
      }
    }
  `);

  // separate variable to load the border images
  const borderStyles = useMemo(() => {
    if (borderStyle === '1') {
      return {
        borderImageSource: `url("${query.borderImageStyleOne?.publicURL}")`,
      };
    }

    if (borderStyle === '2') {
      return {
        borderImageSource: `url("${query.borderImageStyleTwo?.publicURL}")`,
      };
    }

    return {};
  }, [borderStyle, query]);

  return (
    <Col
      {...storyblokEditable(blok)}
      xs={8}
      md={10}
      lg={12}
      className="h-full [border-image-slice:0_fill] pt-[34px] sm:pt-[68px] md:pt-[60px] lg:pt-[68px] pb-[34px]
        sm:pb-[48px] md:pb-[60px] lg:pb-[69px] px-[32px] sm:px-[58px] md:px-[51px] lg:px-[75px]"
      style={borderStyles}
    >
      <Row>
        <div className="w-full">
          {image?.map((nestedBlok) => (
            <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
          ))}
        </div>
      </Row>
      <Row>
        <div className="flex flex-wrap w-full mt-[43px]">
          <p className="basis-full typography-header-s text-beige-100">
            {blok.titleRichText && renderRichTextReact(titleRichText)}
          </p>
          <div className="basis-full my-[40px]">
            <Separator />
          </div>
          <div className="basis-full typography-body-s sm:typography-body-l">
            {blok.description && renderRichTextReact(description)}
          </div>
        </div>
      </Row>
    </Col>
  );
};

ProductCard.propTypes = {
  blok: PropTypes.any.isRequired,
};

export default ProductCard;
